export default __webpack_public_path__ + "static/media/VISCOUS BURGHORROR.89399d75.jpg";